import { render, staticRenderFns } from "./AlertaPrecoHeader.vue?vue&type=template&id=0fe86a3a"
import script from "./AlertaPrecoHeader.vue?vue&type=script&lang=js"
export * from "./AlertaPrecoHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports